module.exports = ".add-btn {\n  position: absolute;\n  right: 0;\n  margin-right: 20px; }\n\n.delete-icon {\n  cursor: pointer; }\n\nth.mat-sort-header-sorted {\n  color: black; }\n\n.mat-column-delete {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 80px;\n          flex: 0 0 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/lifecycle/status-list/status-list.component.scss
// module id = ./src/app/modules/lifecycle/status-list/status-list.component.scss
// module chunks = main